class VideoSection {
  constructor() {
    this.modal = document.getElementById('videoModal');
    this.videoWrapper = document.querySelector('.video-player-wrapper');
    this.carousel = document.querySelector('.video-carousel');
    this.prevButton = document.querySelector('.video-nav-prev');
    this.nextButton = document.querySelector('.video-nav-next');
    this.scrollPosition = 0;
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateNavButtons();
  }

  bindEvents() {
    document.querySelectorAll('.video-thumbnail').forEach(thumbnail => {
      thumbnail.addEventListener('click', (e) => this.openModal(e.currentTarget));
    });

    document.querySelector('.video-modal-close')?.addEventListener('click', () => this.closeModal());

    document.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });

    document.querySelectorAll('.video-nav-button').forEach(button => {
      button.addEventListener('click', (e) => {
        const direction = parseInt(e.currentTarget.dataset.direction);
        this.scrollCarousel(direction);
      });
    });

    if (this.carousel) {
      this.carousel.addEventListener('scroll', () => this.updateNavButtons());
      window.addEventListener('resize', () => this.updateNavButtons());
    }
  }

  updateNavButtons() {
    if (!this.carousel || !this.prevButton || !this.nextButton) return;

    const scrollLeft = this.carousel.scrollLeft;
    const maxScroll = this.carousel.scrollWidth - this.carousel.clientWidth;
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      if (scrollLeft <= 1) {
        this.prevButton.style.display = 'none';
      } else {
        this.prevButton.style.display = 'flex';
      }

      if (scrollLeft >= maxScroll - 1) {
        this.nextButton.style.display = 'none';
      } else {
        this.nextButton.style.display = 'flex';
      }
    } else {
      if (scrollLeft <= 1) {
        this.prevButton.style.display = 'none';
      } else {
        this.prevButton.style.display = 'flex';
      }

      if (scrollLeft >= maxScroll - 1) {
        this.nextButton.style.display = 'none';
      } else {
        this.nextButton.style.display = 'flex';
      }
    }
  }

  openModal(thumbnail) {
    const videoUrl = thumbnail.dataset.videoUrl;
    const videoType = thumbnail.dataset.videoType;
    const instagramHandle = thumbnail.dataset.instagramHandle;
    const instagramUrl = thumbnail.dataset.instagramUrl;
    
    if (!videoUrl || videoUrl === '') {
      console.error('No video URL found');
      alert('Video is not available. Please upload a video file.');
      return;
    }

    this.videoWrapper.innerHTML = '';

    const closeButtonHTML = `
      <button class="video-modal-close">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 1.0605L16.9395 0L9 7.9395L1.0605 0L0 1.0605L7.9395 9L0 16.9395L1.0605 18L9 10.0605L16.9395 18L18 16.9395L10.0605 9L18 1.0605Z" fill="white"/>
        </svg>
      </button>
    `;
    
    this.videoWrapper.insertAdjacentHTML('afterbegin', closeButtonHTML);
    
    const videoElement = document.createElement('video');
    videoElement.setAttribute('controls', '');
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('preload', 'metadata');
    videoElement.setAttribute('crossorigin', 'anonymous');
    videoElement.style.width = '100%';
    videoElement.style.height = '100%';
    videoElement.style.objectFit = 'contain';
    videoElement.style.backgroundColor = '#000';

    videoElement.src = videoUrl;
    videoElement.type = videoType || 'video/mp4';

    this.videoWrapper.appendChild(videoElement);
    
    // Add Instagram attribution section if data exists
    if (instagramHandle && instagramUrl) {
      const instagramHTML = `
        <div class="video-instagram-attribution">
          <div class="video-instagram-content">
            <div class="video-instagram-left">
              <svg class="video-instagram-icon" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <g clip-path="url(#clip0_1449_3799)">
                  <path d="M21.4375 0H6.5625C2.93813 0 0 2.93813 0 6.5625V21.4375C0 25.0619 2.93813 28 6.5625 28H21.4375C25.0619 28 28 25.0619 28 21.4375V6.5625C28 2.93813 25.0619 0 21.4375 0Z" fill="url(#paint0_radial_1449_3799)"/>
                  <path d="M21.4375 0H6.5625C2.93813 0 0 2.93813 0 6.5625V21.4375C0 25.0619 2.93813 28 6.5625 28H21.4375C25.0619 28 28 25.0619 28 21.4375V6.5625C28 2.93813 25.0619 0 21.4375 0Z" fill="url(#paint1_radial_1449_3799)"/>
                  <path d="M14.001 3.0625C11.0306 3.0625 10.6577 3.07552 9.49113 3.12856C8.32672 3.18194 7.53189 3.36623 6.83648 3.63672C6.11702 3.91606 5.50681 4.2898 4.89891 4.89792C4.29045 5.50594 3.91672 6.11614 3.6365 6.83528C3.36525 7.53091 3.18073 8.32606 3.12834 9.48992C3.07617 10.6566 3.0625 11.0296 3.0625 14.0001C3.0625 16.9706 3.07563 17.3423 3.12856 18.5089C3.18216 19.6733 3.36645 20.4681 3.63672 21.1635C3.91628 21.883 4.29002 22.4932 4.89814 23.1011C5.50594 23.7095 6.11614 24.0842 6.83506 24.3635C7.53102 24.634 8.32595 24.8183 9.49014 24.8717C10.6568 24.9247 11.0294 24.9377 13.9997 24.9377C16.9704 24.9377 17.3421 24.9247 18.5087 24.8717C19.6731 24.8183 20.4688 24.634 21.1647 24.3635C21.8839 24.0842 22.4932 23.7095 23.1009 23.1011C23.7093 22.4932 24.083 21.883 24.3633 21.1638C24.6321 20.4681 24.8167 19.6731 24.8714 18.5091C24.9238 17.3425 24.9375 16.9706 24.9375 14.0001C24.9375 11.0296 24.9238 10.6568 24.8714 9.49014C24.8167 8.32573 24.6321 7.53102 24.3633 6.83561C24.083 6.11614 23.7093 5.50594 23.1009 4.89792C22.4925 4.28958 21.8841 3.91584 21.1641 3.63683C20.4668 3.36623 19.6715 3.18183 18.5071 3.12856C17.3404 3.07552 16.969 3.0625 13.9976 3.0625H14.001ZM13.0198 5.03355C13.311 5.03311 13.636 5.03355 14.001 5.03355C16.9214 5.03355 17.2675 5.04405 18.4207 5.09644C19.4871 5.14522 20.0659 5.32339 20.4515 5.47312C20.9619 5.67131 21.3258 5.90833 21.7084 6.29125C22.0912 6.67406 22.3281 7.03861 22.5269 7.54906C22.6766 7.93406 22.855 8.51287 22.9036 9.57928C22.956 10.7323 22.9673 11.0786 22.9673 13.9976C22.9673 16.9166 22.956 17.263 22.9036 18.4159C22.8548 19.4823 22.6766 20.0611 22.5269 20.4462C22.3287 20.9567 22.0912 21.3201 21.7084 21.7027C21.3256 22.0855 20.9622 22.3225 20.4515 22.5208C20.0664 22.6711 19.4871 22.8489 18.4207 22.8977C17.2677 22.95 16.9214 22.9614 14.001 22.9614C11.0805 22.9614 10.7343 22.95 9.58136 22.8977C8.51495 22.8484 7.93614 22.6703 7.55027 22.5205C7.03992 22.3222 6.67527 22.0853 6.29245 21.7025C5.90964 21.3197 5.67273 20.956 5.474 20.4454C5.32427 20.0602 5.14587 19.4814 5.09731 18.415C5.04492 17.262 5.03442 16.9157 5.03442 13.9949C5.03442 11.074 5.04492 10.7296 5.09731 9.57655C5.14609 8.51014 5.32427 7.93133 5.474 7.54578C5.6723 7.03533 5.90964 6.67078 6.29256 6.28797C6.67548 5.90516 7.03992 5.66814 7.55037 5.46952C7.93592 5.31912 8.51495 5.14139 9.58136 5.09239C10.5903 5.04678 10.9814 5.03311 13.0198 5.03081V5.03355ZM19.8394 6.84961C19.1148 6.84961 18.5269 7.43695 18.5269 8.16167C18.5269 8.88628 19.1148 9.47417 19.8394 9.47417C20.564 9.47417 21.1519 8.88628 21.1519 8.16167C21.1519 7.43706 20.564 6.84961 19.8394 6.84961ZM14.001 8.38316C10.8991 8.38316 8.38414 10.8981 8.38414 14.0001C8.38414 17.1021 10.8991 19.6159 14.001 19.6159C17.103 19.6159 19.6171 17.1021 19.6171 14.0001C19.6171 10.8982 17.103 8.38316 14.001 8.38316ZM14.001 10.3542C16.0145 10.3542 17.6469 11.9864 17.6469 14.0001C17.6469 16.0136 16.0145 17.646 14.001 17.646C11.9875 17.646 10.3552 16.0136 10.3552 14.0001C10.3552 11.9864 11.9874 10.3542 14.001 10.3542Z" fill="white"/>
                </g>
                <defs>
                  <radialGradient id="paint0_radial_1449_3799" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(7.4375 30.1565) rotate(-90) scale(27.7501 25.8098)">
                    <stop stop-color="#FFDD55"/>
                    <stop offset="0.1" stop-color="#FFDD55"/>
                    <stop offset="0.5" stop-color="#FF543E"/>
                    <stop offset="1" stop-color="#C837AB"/>
                  </radialGradient>
                  <radialGradient id="paint1_radial_1449_3799" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-4.69011 2.01698) rotate(78.681) scale(12.4044 51.1315)">
                    <stop stop-color="#3771C8"/>
                    <stop offset="0.128" stop-color="#3771C8"/>
                    <stop offset="1" stop-color="#6600FF" stop-opacity="0"/>
                  </radialGradient>
                  <clipPath id="clip0_1449_3799">
                    <rect width="28" height="28" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              <p class="video-instagram-text">Video from the Instagram account</p>
            </div>
            <div class="video-instagram-right">
              <a href="${instagramUrl}" target="_blank" rel="noopener noreferrer" class="video-instagram-handle">${instagramHandle}</a>
              <svg class="video-instagram-link-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5 10.5H1.5V1.5H6V0H1.5C0.675 0 0 0.675 0 1.5V10.5C0 11.325 0.675 12 1.5 12H10.5C11.325 12 12 11.325 12 10.5V6H10.5V10.5ZM7.5 0V1.5H9.8775L3.2475 8.13L4.3725 9.255L11.0025 2.625V4.9725H12.5025V0H7.5Z" fill="#003087"/>
              </svg>
            </div>
          </div>
        </div>
      `;
      this.videoWrapper.insertAdjacentHTML('beforeend', instagramHTML);
    }
    
    videoElement.addEventListener('loadedmetadata', () => {
      videoElement.play().catch(err => {
        console.log('Autoplay prevented. User can click play button.', err);
      });
    });

    videoElement.addEventListener('error', (e) => {
      console.error('Video load error:', e);
      console.error('Video URL:', videoUrl);
      alert('Unable to load video. Please check the video file.');
    });
    
    const newCloseButton = this.videoWrapper.querySelector('.video-modal-close');
    if (newCloseButton) {
      newCloseButton.addEventListener('click', () => this.closeModal());
    }
    
    // Save current scroll position
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    this.modal.classList.add('active');
    document.body.classList.add('modal-open');
    document.body.style.top = `-${this.scrollPosition}px`;
  }

  closeModal() {
    const video = this.videoWrapper.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    
    this.videoWrapper.innerHTML = `
      <button class="video-modal-close">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 1.0605L16.9395 0L9 7.9395L1.0605 0L0 1.0605L7.9395 9L0 16.9395L1.0605 18L9 10.0605L16.9395 18L18 16.9395L10.0605 9L18 1.0605Z" fill="white"/>
        </svg>
      </button>
      <iframe id="videoIframe" src="" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    `;
    
    const newCloseButton = this.videoWrapper.querySelector('.video-modal-close');
    if (newCloseButton) {
      newCloseButton.addEventListener('click', () => this.closeModal());
    }
    
    this.modal.classList.remove('active');
    document.body.classList.remove('modal-open');
    document.body.style.top = '';
    
    // Restore scroll position
    window.scrollTo(0, this.scrollPosition);
  }

  scrollCarousel(direction) {
    if (!this.carousel) return;

    const item = this.carousel.querySelector('.video-item');
    if (!item) return;

    const itemWidth = item.offsetWidth;
    const style = window.getComputedStyle(this.carousel);
    const gap = parseFloat(style.gap) || 17.428;
    const scrollAmount = (itemWidth + gap) * direction;
    
    this.carousel.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });

    setTimeout(() => this.updateNavButtons(), 300);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new VideoSection();
});

